export const colors = [
  "#6BEFA3",
  "#8666EF",
  "#DD7AC6",
  "#FFAB64",
  "#5AAD7D",
  "#BFAF83",
];

export const initialState = {
  lotteryName: "",
  lotteryId: 0,
  contestId: "",
  numbers: [],
  date: "",
  color: "#EFEFEF",
};
